import FeedbackApi from "../generated/api/FeedbackApi";
import FeedbackRequest from "../generated/model/FeedbackRequest";
import EnvService from "../env.settings.js";

class FeedbackService {
    constructor() {
        this.FeedbackApi = new FeedbackApi();
    }

    async CreateSlackMessage(slackMessage) {
        return await window.$A.HandleApiResponse(
            this.FeedbackApi.createSlackMessage(
                {
                    feedbackRequest: FeedbackRequest.constructFromObject(
                        slackMessage
                    ),
                },
                null
            ),
            "",
            true
        );
    }

    _baseUrl() {
        return EnvService.instance.apiHost.replace(/\/+$/, "");
    }

    _authHeader() {
        const token = window.$A && window.$A.Auth && window.$A.Auth.apiToken
            ? window.$A.Auth.apiToken.token
            : "";
        return { AccessToken: token };
    }

    async SubmitCampaignFeedback({ campaignKey, scaleValue, textValue, metadata }) {
        const res = await fetch(`${this._baseUrl()}/feedback/campaign`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...this._authHeader(),
            },
            body: JSON.stringify({
                campaignKey,
                scaleValue: scaleValue == null ? null : Number(scaleValue),
                textValue: textValue || "",
                metadataJson: metadata ? JSON.stringify(metadata) : null,
            }),
        });
        if (!res.ok) {
            const body = await res.text().catch(() => "");
            throw new Error(`Feedback submit failed (${res.status}): ${body}`);
        }
        return res.json();
    }

    async GetMyCampaignResponse(campaignKey) {
        const res = await fetch(
            `${this._baseUrl()}/feedback/campaign/${encodeURIComponent(campaignKey)}/me`,
            { headers: this._authHeader() }
        );
        if (!res.ok) return null;
        const text = await res.text();
        if (!text) return null;
        try { return JSON.parse(text); } catch (_e) { return null; }
    }
}

export default FeedbackService;
